import * as cn from 'classnames'
import * as styles from 'styles/atoms/DescriptionList.css'
import { TooltipIcon } from 'components/features/pfm/Tooltip/TooltipIcon'
import { DEFAULT_MEMBER_EMPTY_VALUE } from 'constants/member'
import { QAMarked } from 'interfaces/component'

export type DescriptionItemType = QAMarked & {
  label: string | number
  value: string | number | null
  hint?: string
}

type DescriptionListProps = {
  items: DescriptionItemType[]
}

const DescriptionItem = ({ label, value, hint, qaMarker, qaType }: DescriptionItemType) => {

  const hintIcon = hint ? (
    <div className={ styles.tooltipIconWrapper } data-qa-type='description-item-icon'>
      <TooltipIcon icon='question'>{ hint }</TooltipIcon>
    </div>
  ) : null

  const hasValue = value !== null
  const normalizedValue = hasValue ? value : DEFAULT_MEMBER_EMPTY_VALUE
  const fieldValueClassName = cn(styles.fieldValue, {
    [styles.dimmed]: !hasValue,
  })

  return (
    <li data-qa-marker={ qaMarker } data-qa-type={ qaType }>
      <div className={ styles.fieldLabel }>
        <div className={ styles.labelText } data-qa-type='description-item-label'>
          { label }
        </div>
        { hintIcon }
      </div>
      <div className={ fieldValueClassName } title={ String(normalizedValue) } data-qa-type='description-item-value'>
        { normalizedValue }
      </div>
    </li>
  )
}

const DescriptionList = ({ items }: DescriptionListProps) => (
  <ul className={ styles.descriptionList }>
    { items.map((item: DescriptionItemType, index: number) => (
      <DescriptionItem key={ index } { ...item } />
    ))}
  </ul>
)


export default DescriptionList
